export interface SessionState {
  session: any;
  isLocalDBComplete:boolean,
  storeWillUpdate: boolean;
  localDBStatus: string;
  memDBStatus: string;
  memDBStats: any;
  noSession: {
    status: AuthenticationState,
    apiUser: {
      id: number,
      login: string,
      nom: string,
      token: string
    },
  };
  dateRange: Array<number>;
  startTime: any;
  interval: number;
  progress: number;
  maxDbSize:number;
  isOffline : boolean;

}

export enum SESSION_STORE {
  /* Mutations */
  SET_SESSION = "SET_SESSION",
  SET_DATERANGE = "setDateRange",
  SET_LOCALDB_COMPLETE="SET_LOCALDB_COMPLETE",
  SET_LOCALDB_STATUS = "SET_LOCALDB_STATUS",
  SET_MEMDB_STATUS = "SET_MEMDB_STATUS",
  SET_MEMDB_STATS = "SET_MEMDB_STATS",
  SET_START_TIME = "SET_START_TIME",
  SET_INTERVAL= "SET_INTERVAL",
  SET_PROGRESS = "SET_PROGRESS",
  SET_STORE_UPDATED = "SET_STORE_UPDATED",
  SET_MAX_DB_SIZE = "SET_MAX_DB_SIZE",
  SET_IS_OFFLINE = "SET_IS_OFFLINE"
}
export enum AuthenticationState {
  Opening,
  Success,
  Faillure,
  Closing,
  Closed
}